/** A word or phrase as the start of a sentence: its first letter capital, the rest as written. */
export const capital = (words: string) => words.charAt(0).toUpperCase() + words.slice(1);

/** What anything being fetched says while it comes: one phrasing, everywhere, in the game's own voice. */
export const LOADING = "Consulting the scrolls…";

/** What the play screen says while the DM rules on what was done. */
export const CONSIDERING = "The DM considers…";
